export default class FilterUtils {

  /**
   * parse filter time
   *
   * @return object with key from and to
   */
  static parseTime = (id) => {
    const now = new Date();
    let from, to;
    from = to = 0;
    if (id === 'today') {
      const fromString = `${now.getFullYear()}-${FilterUtils.formatMonth(
        now.getMonth())}-${FilterUtils.formatDate(
        now.getDate())}T00:00:00+07:00`;
      from = Date.parse(fromString);
    } else if (id === 'yesterday') {
      const toString = `${now.getFullYear()}-${FilterUtils.formatMonth(
        now.getMonth())}-${FilterUtils.formatDate(
        now.getDate())}T00:00:00+07:00`;
      // to is start of today
      to = Date.parse(toString);
      from = to - 24 * 60 * 60 * 1000;
    } else if (id === 'this-week') {
      const fromString = `${now.getFullYear()}-${FilterUtils.formatMonth(
        now.getMonth())}-${FilterUtils.formatDate(
        now.getDate())}T00:00:00+07:00`;
      // from is start of today
      from = Date.parse(fromString);
      // minus day of week
      let day = now.getDay();
      day = (day === 6 ? day : day - 1);
      from -= day * 24 * 60 * 60 * 1000;
    } else if (id === 'this-month') {
      const fromString = `${now.getFullYear()}-${FilterUtils.formatMonth(
        now.getMonth())}-${FilterUtils.formatDate(
        now.getDate())}T00:00:00+07:00`;
      // from is start of today
      from = Date.parse(fromString);
      // minus day of month
      from -= (now.getDate() - 1) * 24 * 60 * 60 * 1000;
    } else {
      // do not filter by time
    }

    const time = {};
    if (from > 0) {
      time.from = from;
    }
    if (to > 0) {
      time.to = to;
    }
    return time;
  };

  /**
   * format month as string with zero padding
   */
  static formatMonth = (month) => {
    month += 1;
    return month < 10 ? `0${month}` : `${month}`;
  };

  /**
   * format date as string with zero padding
   */
  static formatDate = (date) => {
    return date < 10 ? `0${date}` : `${date}`;
  };
}



// WEBPACK FOOTER //
// ./src/utils/FilterUtils.js